'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002e$002dMeal$002dType from "./mealorama.-Meal-Type.js";
var $p;
/** @constructor */
function $c_Lmealorama_MealType$$anon$1() {
  this.uC = 0;
  this.rk = null;
  this.wA = null;
  $j_mealorama$002e$002dMeal$002dType.$ct_Lmealorama_MealType__I__T__T__(this, 0, "breakfast", "Breakfast");
}
export { $c_Lmealorama_MealType$$anon$1 as $c_Lmealorama_MealType$$anon$1 };
$p = $c_Lmealorama_MealType$$anon$1.prototype = new $j_mealorama$002e$002dMeal$002dType.$h_Lmealorama_MealType();
$p.constructor = $c_Lmealorama_MealType$$anon$1;
/** @constructor */
function $h_Lmealorama_MealType$$anon$1() {
}
export { $h_Lmealorama_MealType$$anon$1 as $h_Lmealorama_MealType$$anon$1 };
$h_Lmealorama_MealType$$anon$1.prototype = $p;
$p.q = (function() {
  return 0;
});
$p.g = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.r = (function() {
  return "breakfast";
});
$p.m = (function() {
  return "breakfast";
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__hashCode__I("breakfast");
});
var $d_Lmealorama_MealType$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_MealType$$anon$1, "mealorama.MealType$$anon$1", ({
  Gv: 1,
  cb: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1,
  n: 1,
  d: 1,
  e: 1,
  h: 1
}));
export { $d_Lmealorama_MealType$$anon$1 as $d_Lmealorama_MealType$$anon$1 };
//# sourceMappingURL=mealorama.-Meal-Type$$anon$1.js.map
